import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { Badge } from '@prisjakt/ui/badge';

export const StyledBadge = styled(Badge)`
  ${media.largeUp`
    margin-right: ${layout.measurements.spacing025};
  `}
`;
